import React from "react";
import { Box, IconButton } from "@mui/material";
import { Cancel, CheckCircle, Delete } from "@mui/icons-material";

export const icdLeftColumns = [
  { field: "icd_code", headerName: "Code", flex: 1 },
  { field: "condition_name", headerName: "Condition Name", flex: 2 },
  { field: "raf_impact", headerName: "RAF Impact", flex: 1 },
];

export const icdRightColumns = (handleUpdate, handleDelete) => {
  return [
    {
      field: "action",
      headerName: "Action",
      width: 250,
      renderCell: (e) => {
        const decision = e.row?.user_decision || "pending";
        const showDelete = e.row?.recommendation_type === "manual";
        return (
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton
              color="error"
              disabled={decision === "rejected"}
              onClick={() => handleUpdate(e.row, "rejected", "ICD")}
              size="small"
            >
              <Cancel />
            </IconButton>
            <IconButton
              color="success"
              disabled={decision === "accepted"}
              onClick={() => handleUpdate(e.row, "accepted", "ICD")}
              size="small"
            >
              <CheckCircle />
            </IconButton>
            {showDelete && (
              <IconButton
                color="error"
                size="small"
                onClick={() => handleDelete(e.row, "ICD")}
                sx={{ ml: 1 }}
              >
                <Delete />
              </IconButton>
            )}
          </Box>
        );
      },
    },
    { field: "icd_code", headerName: "Code", width: 130 },
    { field: "condition_name", headerName: "Condition Name", width: 250 },
    { field: "raf_impact", headerName: "RAF Impact", width: 130 },

    { field: "user_decision", headerName: "User Decision", width: 150 },
  ];
};

export const cptLeftColumns = [
  {
    field: "cpt_code",
    headerName: "Code",
    width: 150,
    renderCell: (params) => {
      const code = params.row.cpt_code || "";
      const mods = [
        params.row.modifier_1,
        params.row.modifier_2,
        params.row.modifier_3,
        params.row.modifier_4,
      ]
        .filter(Boolean)
        .join(",");
      return <span>{mods ? `${code}-${mods}` : code}</span>;
    },
  },
  { field: "condition_name", headerName: "Condition Name", width: 250 },

  { field: "complexity_level", headerName: "Complexity Level", width: 150 },
  { field: "rvu_value", headerName: "RVU", width: 100 },
];

export const cptRightColumns = (handleUpdate, handleDelete) => {
  return [
    {
      field: "action",
      headerName: "Action",
      width: 250,
      renderCell: (e) => {
        const decision = e.row?.user_decision || "pending";
        const showDelete = e.row?.recommendation_type === "manual";
        return (
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton
              color="error"
              disabled={decision === "rejected"}
              onClick={() => handleUpdate(e.row, "rejected", "CPT")}
              size="small"
            >
              <Cancel />
            </IconButton>
            <IconButton
              color="success"
              disabled={decision === "accepted"}
              onClick={() => handleUpdate(e.row, "accepted", "CPT")}
              size="small"
            >
              <CheckCircle />
            </IconButton>
            {showDelete && (
              <IconButton
                color="error"
                size="small"
                onClick={() => handleDelete(e.row, "CPT")}
                sx={{ ml: 1 }}
              >
                <Delete />
              </IconButton>
            )}
          </Box>
        );
      },
    },
    {
      field: "cpt_code",
      headerName: "Code",
      width: 150,
      renderCell: (params) => {
        const code = params.row.cpt_code || "";
        const mods = [
          params.row.modifier_1,
          params.row.modifier_2,
          params.row.modifier_3,
          params.row.modifier_4,
        ]
          .filter(Boolean)
          .join(",");
        return <span>{mods ? `${code}-${mods}` : code}</span>;
      },
    },
    { field: "condition_name", headerName: "Condition Name", width: 250 },

    { field: "complexity_level", headerName: "Complexity Level", width: 150 },
    { field: "rvu_value", headerName: "RVU", width: 100 },
    { field: "user_decision", headerName: "User Decision", width: 140 },
  ];
};
